import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

type Props = {
  title: string;
  lead?: string;
  crumb: string;
  children?: React.ReactNode;
};

/** Dark band that opens every inner page: breadcrumb, one h1, one line of context. */
const PageHead: React.FC<Props> = ({ title, lead, crumb, children }) => (
  <header className="page-head on-dark">
    <div className="container">
      <nav className="crumbs" aria-label="Ruta de navegación">
        <ol>
          <li>
            <Link to="/">
              <Icon name="home" />
              Inicio
            </Link>
          </li>
          <li>
            <span aria-current="page">{crumb}</span>
          </li>
        </ol>
      </nav>
      <h1>{title}</h1>
      {lead && <p className="lead">{lead}</p>}
      {children}
    </div>
  </header>
);

export default PageHead;
